import React, {useState, useEffect} from "react";
import {useLocation, Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//helpers:
import {checkIsActive} from "../../../../_helpers";

//components:
import {Dropdown} from "react-bootstrap";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

//actions:
import {tracksActions} from "../../../../../app/redux/Tracks/tracksRedux";
import {trackPageActions} from "../../../../../app/redux/TrackPage/trackPageRedux";
import {queryActions} from "../../../../../app/redux/Query/queryRedux";

const TracksDropdown = () => {
    const location = useLocation();
    const {t} = useTranslation();

    //redux:
    //store:
    const tracks = useSelector(state => state.tracks.normalTracks);
    const isTrackPage = useSelector(state => state.layout.isTrackPage);
    //actions:
    const dispatch = useDispatch();

    const getNormalTracks = () => dispatch(tracksActions.getNormalTracks());
    const clearTrackPage = () => dispatch(trackPageActions.clearTrackPage());
    const clearSearcher = () => dispatch(queryActions.clearSearcher());

    //local state:
    const [selectedTrackId, setSelectedTrackId] = useState(null);

    useEffect(() => {
        if (tracks && !tracks[0]) getNormalTracks();
    }, []);

    useEffect(() => {
        if (isTrackPage) {
            const numberInUrl = location.pathname.match(/\d+/) && location.pathname.match(/\d+/)[0];

            setSelectedTrackId(numberInUrl ? Number(numberInUrl) : null);
        } else {
            setSelectedTrackId(null);
        }
    }, [location.pathname, isTrackPage]);

    const getMenuItemActive = (url, exact) => {
        return checkIsActive(location, url, exact) ? "menu-item-active" : "";
    };

    const handleSelect = trackId => {
        if (selectedTrackId !== trackId) {
            clearSearcher();
            clearTrackPage();
        }
    };

    return (
        <Dropdown>
            <Dropdown.Toggle className={`tracks_header_toggle ${getMenuItemActive("/track/") ? "active_navlink" : ""}`}>
                <span className="menu-text">
                    {t("GENERAL.TRACKS")}
                    <KeyboardArrowDownIcon />
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="header_menu_list">
                {tracks?.[0]?.name ? (
                    tracks.map((track, i) => (
                        <Link
                            key={`${track.name}-${i}`}
                            className={`${
                                selectedTrackId === track?.track_id ? "bg-primary text-white" : ""
                            } elipsis_1line dropdown-item`}
                            onClick={() => handleSelect(track?.track_id)}
                            to={`/track/${track?.track_id}`}
                        >
                            {track?.name}
                        </Link>
                    ))
                ) : (
                    <span className={`py-4 pl-4 pr-2  elipsis_1line dropdown-item`}>
                        {t("HEADER.BUTTON.TRACKS.PLACEHOLDER")}
                    </span>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default TracksDropdown;
